export enum Notification {
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Error = 'error',
}
